import { Roles } from '../Data/Users';
import { levels } from '../Data/Admin';

const newMenu = [
    {
        title: 'Home',
        icon: 'HouseChimney',
        notifications: true,
        items: [
            {
                label: 'Dashboard',
                icon: 'HouseChimney',
                to: '/',
                pinnable: false,
            },
            {
                label: 'Reports',
                icon: 'ChartSimple',
                to: '/reports',
                role: Roles.Manager,
            },
        ]
    },
    /*
    {
        title: 'Admin',
        icon: 'Cog',
        items: [
            {
                disabled: true,
                label: 'Website',
                icon: 'GlobePointer',
                to: '/website',
            },
            {
                disabled: true,
                label: 'Account',
                icon: 'User',
                to: '/user',
            },
            {
                // disabled: true,
                label: 'Business',
                icon: 'Building',
                to: '/business/details',
            },
            {
                disabled: true,
                label: 'Payments',
                icon: 'MoneyBillTransfer',
                to: '/manage/payments',
            },
            {
                disabled: true,
                label: 'Messaging',
                icon: 'PaperPlane',
                to: '/manage/messaging',
            },
            {
                // disabled: true,
                label: 'Reports',
                icon: 'ChartSimple',
                to: '/reports',
            },
            {
                label: 'More',
                icon: 'LayerGroup',
                to: '/more',
            }
        ]
    },
    */
    {
        title: 'Manage',
        icon: 'ChartSimple',
        role: Roles.Manager,
        items: [
            {
                label: 'Customers',
                icon: 'Users',
                to: '/manage/customers',
                feature: 'CUSTOMERS',
            },
            {
                label: 'Quotes',
                icon: 'FileInvoice',
                to: '/manage/quotes',
            },
            {
                label: 'Invoices',
                icon: 'FileInvoiceDollar',
                to: '/manage/invoices',
            },
            {
                label: 'Payments',
                icon: 'MoneyBillWave',
                to: '/manage/payments',
            },
            {
                label: 'Payouts',
                icon: 'MoneyBillTransfer',
                to: '/settings/payments/payouts',
                feature: 'CARDS_PAYMENTS',
                role: Roles.Owner,
            },
            {
                label: 'Expenses',
                icon: 'Receipt',
                to: '/manage/expenses',
                feature: 'EXPENSES',
            },
            {
                label: 'Broadcasts',
                icon: 'Bullhorn',
                to: '/more/broadcasts',
                feature: 'BROADCASTS',
            },
            {
                label: 'Leads',
                icon: 'UserPlus',
                to: '/plan/leads',
            },
            // {
            //     disabled: true,
            //     label: 'Invoices',
            //     icon: 'FileInvoiceDollar',
            //     to: '/manage/invoices',
            // }
        ]
    },
    {
        title: 'Plan',
        icon: 'Calendar',
        role: Roles.Manager,
        items: [
            {
                label: 'Calendar',
                icon: 'Calendar',
                to: '/calendar',
                feature: 'WEEK_PLANNER',
            },
            {
                label: 'Rounds',
                icon: 'Route',
                to: '/rounds',
                feature: 'ROUNDS',
            },
            {
                label: 'Jobs',
                icon: 'Toolbox',
                to: '/plan/jobs',
            },
        ]
    },
    {
        title: 'Admin',
        icon: 'Wrench',
        admin: levels.READ_ONLY,
        items: [
            {
                label: 'Admin Panel',
                icon: 'Wrench',
                to: '/admin',
            },
            {
                label: 'Conversations',
                icon: 'Comment',
                to: '/admin/conversations',
            },
            {
                label: 'Businesses',
                icon: 'Building',
                to: '/admin/businesses',
            },
            {
                label: 'Assistant',
                icon: 'Robot',
                to: '/admin/assistant',
            },
        ]
    },
];

export default newMenu;
